import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { text: String }
  static targets = ["button", "icon"]

  async copy() {
    try {
      await navigator.clipboard.writeText(this.textValue)
      this.showCopied()
    } catch {
      // Fallback for older browsers
      const textarea = document.createElement("textarea")
      textarea.value = this.textValue
      textarea.style.position = "fixed"
      textarea.style.opacity = "0"
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand("copy")
      document.body.removeChild(textarea)
      this.showCopied()
    }
  }

  showCopied() {
    if (this.hasIconTarget) {
      const original = this.iconTarget.innerHTML
      this.iconTarget.innerHTML = '<path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4.5 12.75l6 6 9-13.5" />'
      setTimeout(() => {
        this.iconTarget.innerHTML = original
      }, 2000)
    }
  }
}
